import React from 'react';
import { Box, Text, HStack } from 'native-base';

var SOURCE_CONFIG = {
  doshii: {
    label: 'Synced from POS',
    color: 'green.600',
    bg: 'green.100',
    description: 'Menu data is automatically synced from your point-of-sale system.',
  },
  manual: {
    label: 'Manually entered',
    color: 'blue.600',
    bg: 'blue.100',
    description: 'Menu data is managed directly in Piatto.',
  },
  none: {
    label: 'No menu integration',
    color: 'coolGray.600',
    bg: 'coolGray.100',
    description: 'Add menu items manually in the Menu section.',
  },
};

function DataSourceIndicator({ source }) {
  var current = SOURCE_CONFIG[source] || SOURCE_CONFIG.none;

  return (
    <Box bg={current.bg} p={3} borderRadius="md" borderLeftWidth={3} borderLeftColor={current.color} mb={3}>
      <Text fontWeight="semibold" fontSize="sm" color={current.color}>
        {current.label}
      </Text>
      <Text fontSize="xs" color="coolGray.600" mt={1}>
        {current.description}
      </Text>
    </Box>
  );
}

export default DataSourceIndicator;
